import { Outlet, Route } from 'react-router-dom';
import { WelcomeScreen } from './screens/WelcomeScreen';
import { VerificationScreen } from './screens/VerificationScreen';
import { ProductsScreen } from './screens/ProductsScreen';
import ProtectedRoute from 'src/routes/ProtectedRoute';
import { VerificationTokenProvider } from 'src/features/auth/presentation/providers/VerificationTokenProvider';
import { AppSubdomains } from 'src/types/common';

export const specializedStoresRoutes = (
  <>
    <Route
      element={
        <ProtectedRoute
          includedSubdomains={[AppSubdomains.Terea]}
          disableAuthProtection
        >
          <VerificationTokenProvider>
            <Outlet />
          </VerificationTokenProvider>
        </ProtectedRoute>
      }
    >
      <Route path="welcome" element={<WelcomeScreen />} />
      <Route path="verify" element={<VerificationScreen />} />
    </Route>
    <Route
      path="products"
      element={
        <ProtectedRoute includedSubdomains={[AppSubdomains.Terea]}>
          <ProductsScreen />
        </ProtectedRoute>
      }
    />
  </>
);
